import React from 'react';
import {Radio} from 'antd';
import {Colors} from '../../styles/Colors';
import {GlobalStyleAttributes} from '../../styles/GlobalStyles';
import HStack from './Layout/HStack';
import AppText from './AppText';

const RadioListItem = (props) => {
    const {label, isSelected, onSelect, endContent, showBottomBorder = true} = props;

    const onRadioChange = (e) => {
        e.stopPropagation();
        onSelect();
    };

    return (
        <div onClick={() => onSelect()} style={{width: '100%', cursor: isSelected ? 'default' : 'pointer'}}>
            <HStack
                alignItems={'center'}
                space={'0.75rem'}
                style={{
                    height: '48px',
                    padding: '0 12px',
                    backgroundColor: isSelected ? Colors.newDesign.lightBlue : Colors.newDesign.white,
                    ...(showBottomBorder ? {borderBottom: `1px solid ${Colors.borderColor}`} : {}),
                }}
            >
                <Radio checked={isSelected} onChange={onRadioChange} onClick={(e) => e.stopPropagation()}/>
                <AppText
                    fontSize={GlobalStyleAttributes.fonts.standard16}
                    color={isSelected ? Colors.newDesign.mainBlue : Colors.newDesign.mainText}
                    style={{flex: 1}}
                >
                    {label}
                </AppText>
                {endContent}
            </HStack>
        </div>
    );
};

export default RadioListItem;
